import { getEventEuroDesktop } from "app/api/eventsApi";
import debounce from "lodash/debounce";
import difference from "lodash/difference";
import isEmpty from "lodash/isEmpty";
import { PureComponent } from "react";
import { connect } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import DangerZoneTextOnly from "../../../../components/DangerZoneTextOnly/DangerZoneTextOnly";
import { EventHelper } from "../../../../helpers/eventHelper";
import { FavouritesHelper } from "../../../../helpers/favouritesHelper";
import { SessionHelper } from "../../../../helpers/sessionHelper";
import type {
  EventMarketPeriodType,
  EventType,
} from "../../../../types/eventType";
import type { UserType } from "../../../../types/userType";
import { EventStatus, PollingIntervals } from "../../../../utils/const";
import AsianEventCell from "../../../AsianEventsScreen/components/AsianEventCellModal/AsianEventCellModal";
import PopularEventCellRow from "./components/PopularEventCellRow/PopularEventCellRow";
import { CheckDangerZoneSideHelper } from "./helpers/CheckDangerZoneSideHelper/CheckDangerZoneSideHelper";
import { CheckIfEventIsInBetslipHelper } from "./helpers/CheckIfEventIsInBetslipHelper/CheckIfEventIsInBetslipHelper";
import { ExtraTimeScoresHelper } from "./helpers/ExtraTimeScoresHelper/ExtraTimeScoresHelper";
import { GetListOfMarketIDsHelper } from "./helpers/GetListOfMarketIDsHelper/GetListOfMarketIDsHelper";
import { HasClosedMarketHelper } from "./helpers/HasClosedMarketHelper/HasClosedMarketHelper";
import { PopularEventStatusHelper } from "./helpers/PopularEventStatusHelper/PopularEventStatusHelper";
import "./PopularEventCell.scss";
//
type Props = {
  data: EventType;
  setEvent: Function;
  history: any;
  subscribeEvent: Function;
  unsubscribeEvent: Function;
  subscribeMarkets: Function;
  unsubscribeMarkets: Function;
  isIdle: boolean;
  resizeCell: Function;
  competitionIndex: number;
  betSlipList: any;
  favouritesOnly: boolean;
  addFavouriteToList: Function;
  removeFromFavouritesList: Function;
  line: string;
  index: number;
  isCompetitionLive: boolean;
  toggleAddRemoveToFavorites: Function;
  isEventLoading: boolean;
  getFavouriteList: Function;
  eventHasGoneLive: any;
  updateUnsumm: Function;
  user: UserType;
  searchResultModalActive: boolean;
  listSize: number;
  competitionIsVisible: boolean;
  marketType: string;
  setCompetitionList: Function;
};

type State = {
  intervalStarted: boolean;
  isActive: boolean;
  isFavourite: boolean;
  isEventLoading: boolean;
  showGraphExpanded?: boolean;
};

class PopularEventCell extends PureComponent<Props, State> {
  debouncedfetchEventData: any;
  constructor(props: Props) {
    super(props);
    this.state = {
      intervalStarted: false,
      isActive: false,
      isFavourite: this.props.data.favourite,
      isEventLoading: false,
    };

    this.debouncedfetchEventData = debounce(this.fetchEventData, 1000);
  }
  // Not using state to store intrevalId because was causing some timing issues, See BET-4963
  intervalId;
  isWaitingToFetch;

  componentWillUnmount() {
    // Unsubscribe event and all its markets
    const { data, unsubscribeEvent, unsubscribeMarkets } = this.props;
    const eventInBetslip =
      CheckIfEventIsInBetslipHelper.checkIfEventIsInBetslip(data.id);
    if (!eventInBetslip) {
      unsubscribeEvent(data.id);
      // if (data.type === "EuropeanEvent") {
      if (data.marketPeriods) {
        const marketIdList =
          data.marketPeriods &&
          !isEmpty(data.marketPeriods) &&
          data.marketPeriods[0].marketTypes.map(
            marketType => marketType.markets[0].id
          );
        // unsubscribe markets
        marketIdList && unsubscribeMarkets(marketIdList);
      }
    }
    // Clear interval for fetching event
    this.endIntervalFetchEvent();
    this.setState({
      isEventLoading: false,
    });
    this.debouncedfetchEventData.cancel();
  }
  /**
   * Toggle event details open/closed.
   * If runnerForGraph is present then toggle with market data graph section opened
   * and display the chart for the runner passed here
   *
   */
  toggleAlternativeLines = () => {
    // set the event
    const { data } = this.props;
    const { resizeCell, competitionIndex } = this.props;
    if (data.showAlternativeLines) {
      this.props.setEvent(Object.assign(data, { showAlternativeLines: false }));
    } else {
      this.props.setEvent(Object.assign(data, { showAlternativeLines: true }));
    }
    this.fetchEventData(data.id);
    if (!SessionHelper.isAsianRoute()) {
      resizeCell(competitionIndex);
    }
  };

  updateMarketsWebsocketSubscriptions(prevProps) {
    // If any markets have been added, subscribe to websockets
    // If any markets have been removed, unsubscribe fromwebsockets
    const { data } = this.props;

    if (data) {
      //  european view data structure
      const eurPrevMarketIds =
        prevProps.data && prevProps.data.marketPeriods
          ? GetListOfMarketIDsHelper.getListOfMarketIDs(
              prevProps.data.marketPeriods
            )
          : [];
      const eurCurrentMarketIds = data.marketPeriods
        ? GetListOfMarketIDsHelper.getListOfMarketIDs(data.marketPeriods)
        : [];
      const euroMarketsAdded = difference(
        eurCurrentMarketIds,
        eurPrevMarketIds
      );
      const euroMarketsRemoved = difference(
        eurPrevMarketIds,
        eurCurrentMarketIds
      );
      euroMarketsAdded &&
        euroMarketsAdded.length > 0 &&
        this.props.subscribeMarkets(euroMarketsAdded);
      euroMarketsRemoved &&
        euroMarketsRemoved.length > 0 &&
        this.props.unsubscribeMarkets(euroMarketsRemoved);
    }
  }

  componentDidMount() {
    const { data, subscribeMarkets } = this.props;
    const currMarketIds = GetListOfMarketIDsHelper.getListOfMarketIDs(
      data.marketPeriods
    );
    subscribeMarkets(currMarketIds);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      data,
      resizeCell,
      competitionIndex,
      eventHasGoneLive,
      setCompetitionList,
    } = this.props;
    this.updateMarketsWebsocketSubscriptions(prevProps);
    // if a market has been closed/removed,
    // need to fetch the event to replace the closed market
    // eg total (-0.75) is removed so need to show a different total market instead
    data.status === EventStatus.OPEN &&
      data.marketPeriods &&
      data.marketPeriods.forEach(mp => {
        // To prevent multiple fetches when multiple markets close:
        // - check if already waiting to fetch
        // - if not waiting, then start a wait
        // - do a fetch when the time is up and reset the waiting
        if (
          !this.isWaitingToFetch &&
          HasClosedMarketHelper.hasClosedMarket(mp)
        ) {
          this.isWaitingToFetch = true;
          this.debouncedfetchEventData(data.id);
        }
      });
    // BET-5979 Firefox fix to force API call to remove closed event from competitions list
    if (prevProps.data.status === "OPEN" && data.status === "CLOSED") {
      setCompetitionList();
    }

    if (
      SessionHelper.isAsianRoute() &&
      !prevProps.data["inRunning"] &&
      data["inRunning"]
    ) {
      // event has gone live
      eventHasGoneLive();
      resizeCell(competitionIndex);
    }
  }

  onEventVisible = (
    isVisible: boolean,
    eventId: number,
    eventIsActive: boolean,
    eventType: string,
    marketPeriods: EventMarketPeriodType[],
    marketPeriodsSummary: EventMarketPeriodType[]
  ) => {
    let marketIds = [];
    const {
      betSlipList,
      subscribeEvent,
      unsubscribeEvent,
      subscribeMarkets,
      unsubscribeMarkets,
    } = this.props;
    if (marketPeriods && marketPeriods.length > 0) {
      marketIds = GetListOfMarketIDsHelper.getListOfMarketIDs(marketPeriods);
    }
    const eventInBetslip =
      CheckIfEventIsInBetslipHelper.checkIfEventIsInBetslip(
        eventId,
        betSlipList
      );
    // If event is visible then subscribe otherwise unsubscribe
    if (isVisible) {
      subscribeEvent(eventId);
      this.startIntervalFetchEvent();
    } else {
      //unsubscribe only if event is not in betslip
      if (!eventInBetslip) {
        unsubscribeEvent(eventId);
        this.endIntervalFetchEvent();
      }
    }
    // If event is visible AND market is expanded then subscribe
    if (isVisible && marketIds && marketIds.length > 0) {
      subscribeMarkets(marketIds);
    } else {
      if (!eventInBetslip) {
        marketIds && unsubscribeMarkets(marketIds);
      }
    }
  };
  /**
   * update event every 30 sec
   */
  startIntervalFetchEvent = () => {
    const { data, isEventLoading } = this.props;
    if (SessionHelper.isAsianRoute()) return;
    // BET - 3726 disable intial getevents
    // this is undefined inside timer
    if (!this.state.intervalStarted) {
      this.intervalId = setInterval(() => {
        // if user session idle stop polling
        if (this.props.isIdle || isEventLoading) return;
        // issue where this is called each time isVisible = true
        // resulting in numerous calls being made at once
        // this.fetchEventData(data.id);
      }, PollingIntervals.EVENT);

      this.setState({
        intervalStarted: true,
      });
    }
  };

  endIntervalFetchEvent = () => {
    if (SessionHelper.isAsianRoute()) return;
    clearInterval(this.intervalId);
    this.setState({
      intervalStarted: false,
    });
  };

  fetchEventData = id => {
    this.isWaitingToFetch = false;
    const showAlternativeLines = this.props.data.showAlternativeLines || false;
    getEventEuroDesktop(id, showAlternativeLines, this.props.data.sportType)
      .then(eventData => {
        Object.assign(eventData, {
          showAlternativeLines: showAlternativeLines,
        });
        this.props.setEvent(eventData);
        const currMarketIds = GetListOfMarketIDsHelper.getListOfMarketIDs(
          eventData.marketPeriods
        );
        if (showAlternativeLines) {
          const altMarketIds = GetListOfMarketIDsHelper.getListOfMarketIDs(
            eventData.alternativeMarketPeriods
          );
          altMarketIds &&
            altMarketIds.length > 0 &&
            this.props.subscribeMarkets(altMarketIds);
        }
        currMarketIds &&
          currMarketIds.length > 0 &&
          this.props.subscribeMarkets(currMarketIds);
        this.props.resizeCell(this.props.competitionIndex);
        if (this.state.isEventLoading) {
          this.props.resizeCell(this.props.competitionIndex);
          this.setState({
            isEventLoading: false,
          });
        }
      })
      .catch(error => {
        throw error;
      });
  };
  // toggling add/remove favourites by clicking favourites button
  toggleAddRemoveToFavorites = (eventId: number) => {
    let { favouritesOnly } = this.props;
    if (!this.state.isFavourite) {
      this.props.addFavouriteToList(eventId, () => {
        FavouritesHelper.updateFavourite(eventId, favouritesOnly);
      });
    } else {
      this.props.removeFromFavouritesList(eventId, () => {
        FavouritesHelper.updateFavourite(eventId, favouritesOnly);
      });
    }
    this.setState({
      isFavourite: !this.state.isFavourite,
    });
  };
  //
  render() {
    const {
      data,
      listSize,
      competitionIsVisible,
      index,
      competitionIndex,
      resizeCell,
    } = this.props;
    const { isFavourite, isEventLoading } = this.state;
    let markets = [];
    markets = data.marketPeriods;
    // There are two situations when there are no prices, need so show appropriate message for each
    // - no prices available
    // - prices are filtered by user setting minimum liquidity limit
    const noOddsMessage = "events-no-odds";
    const eventIncidents = data["eventIncidents"];
    const status = data.status.toLowerCase();
    const numberOfMarkets = data["numberOfMarkets"];
    const isEventInExtraTime = EventHelper.isEventInExtraTime(data);
    const isBeforeExtraTime = EventHelper.isBeforeExtraTime(data);
    const showAlternativeLines: boolean = data.showAlternativeLines || false;
    let side = "";
    side =
      eventIncidents &&
      CheckDangerZoneSideHelper.checkDangerZoneSide(eventIncidents);
    // get full time score in extra time
    const scoreFullTime =
      eventIncidents &&
      ExtraTimeScoresHelper.displayFullTimeScoreInExtraTimeScores(
        eventIncidents,
        "fullTime"
      );

    if (SessionHelper.isAsianRoute()) {
      return (
        <VisibilitySensor
          onChange={isVisible =>
            this.onEventVisible(
              isVisible,
              data.id,
              data.isActive,
              data.type,
              data.marketPeriods || [],
              data.marketPeriodsSummary || []
            )
          }
        >
          <AsianEventCell
            event={data}
            index={index}
            competitionIndex={competitionIndex}
            toggleAddRemoveToFavorites={this.toggleAddRemoveToFavorites}
            isEventLoading={isEventLoading}
            competitionIsVisible={competitionIsVisible}
            listSize={listSize}
          />
        </VisibilitySensor>
      );
    } else {
      // European view
      let statusText = PopularEventStatusHelper.getEventStatus(status);
      return (
        <VisibilitySensor
          onChange={isVisible =>
            this.onEventVisible(
              isVisible,
              data.id,
              data.isActive,
              data.type,
              data.marketPeriods || [],
              data.marketPeriodsSummary || []
            )
          }
          partialVisibility={true}
        >
          <PopularEventCellRow
            isEventLoading={isEventLoading}
            statusText={statusText}
            data={data}
            toggleAddRemoveToFavorites={() =>
              this.toggleAddRemoveToFavorites(data.id)
            }
            isEventInExtraTime={isEventInExtraTime}
            scoreFullTime={scoreFullTime}
            isBeforeExtraTime={isBeforeExtraTime}
            isFavourite={isFavourite}
            side={side}
            eventIncidents={eventIncidents}
            DangerZoneTextOnly={DangerZoneTextOnly}
            numberOfMarkets={numberOfMarkets}
            toggleAlternativeLines={this.toggleAlternativeLines}
            noOddsMessage={noOddsMessage}
            showAlternativeLines={showAlternativeLines}
            resizeCell={resizeCell}
            competitionIndex={competitionIndex}
            status={status}
          />
        </VisibilitySensor>
      );
    }
  }
}

const mapStateToProps = state => ({
  isIdle: state.sessionModel.isIdle,
  betSlipList: state.betSlipListModel.betSlipList,
  currentFavouritesCount: state.favouritesListModel.currentFavouritesCount,
  favouritesOnly: state.competitionListModel.favouritesOnly,
  user: state.userModel.user,
  searchResultModalActive: state.competitionListModel.searchResultModalActive,
  marketType: state.competitionListModel.marketType,
});

function mapDispatchToProps(dispatch) {
  return {
    setEvent: (event: EventType) => {
      if (SessionHelper.isAsianRoute()) {
        dispatch.competitionListModel.updateEventInAsianCompetitionInList(
          event
        );
      } else {
        dispatch.competitionListModel.updateEventInCompetitionInList(event);
      }
    },
    setCompetitionList: () => {
      dispatch.competitionListModel.setEuroCompetitionList();
    },
    subscribeEvent: (eventId: number) =>
      dispatch.subscribeModel.subscribeEvent({ eventId }),

    unsubscribeEvent: (eventId: number) =>
      dispatch.subscribeModel.unsubscribeEvent({ eventId }),

    subscribeMarkets: (marketIdList: number[]) =>
      dispatch.subscribeModel.subscribeMarkets({ marketIdList }),

    unsubscribeMarkets: (marketIdList: number[]) =>
      dispatch.subscribeModel.unsubscribeMarkets({ marketIdList }),

    addFavouriteToList: (eventId, callback) =>
      dispatch.favouritesListModel.addFavouriteToList({ eventId, callback }),

    removeFromFavouritesList: (eventId, callback) =>
      dispatch.favouritesListModel.removeFromFavouriteToList({
        eventId,
        callback,
      }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PopularEventCell);
